import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PersonalDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile, country } = location.state || {};
  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isFormValid = name.trim().length >= 3 && validateEmail(email);

  const handleSubmit = async () => {
    if (!isFormValid) {
      alert('Please fill in all fields correctly.');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('mobile', mobile);
      formData.append('name', name);
      formData.append('email', email);
      formData.append('country', country);
      
      const response = await fetch('https://singlewindowsecurities.com/rest3/web_otp_verify_api2', {
        method: 'POST',
        body: formData,
      });    
      const result = await response.json();
      console.log(result);
      
      if (result.status==0) {
        alert(result.msg);
        navigate(`/kyc/${result.lid}`);
      } else {
        alert(result.message || 'Registration failed. Please try again.');
        setLoading(false);
      }
    } catch (error) {
      alert('Failed to connect to the server. Please try again later.');
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Top Gradient Section - Dark Golden */}
      <div style={{ 
        background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
        borderBottomLeftRadius: '30px', 
        borderBottomRightRadius: '30px',
        minHeight: '130px',
        boxShadow: '0 4px 20px rgba(212, 175, 55, 0.2)'
      }}>
        <div className="container py-4">
          <div className="text-center text-dark">
            <h5 className="fw-bold" style={{ letterSpacing: '1px' }}>Personal Details</h5>
            <p className="mb-0 opacity-75 text-dark">Complete your profile information</p>
          </div>
        </div>
      </div>

      {/* User Info Preview - Dark Theme */}
      <div className="container mt-3">
        <div className="card mb-3 rounded-3" style={{ 
          background: 'rgba(20, 20, 20, 0.95)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          backdropFilter: 'blur(10px)'
        }}>
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="rounded-circle p-2 me-3" style={{ 
                background: 'rgba(212, 175, 55, 0.1)'
              }}>
                <i className="fa fa-person" style={{ color: '#D4AF37' }}></i>
              </div>
              <div className="flex-grow-1">
                <h6 className="mb-0 fw-bold text-white">{mobile || '+91XXXXXXXXXX'}</h6>
                <small style={{ color: '#888' }}>Verified • {country || 'India'}</small>
              </div>
              <i className="fa fa-check-circle-fill fs-5" style={{ color: '#D4AF37' }}></i>
            </div>
          </div>
        </div>
      </div>

      {/* Main Form Card - Dark Theme */}
      <div className="container">
        <div className="card rounded-4" style={{ 
          background: 'rgba(20, 20, 20, 0.95)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
        }}>
          <div className="card-body p-4">
            {/* Form Header */}
            <div className="d-flex align-items-center mb-4 pb-3" style={{ borderBottom: '1px solid rgba(212, 175, 55, 0.2)' }}>
              <div className="rounded-circle p-2 me-3" style={{ 
                background: 'rgba(212, 175, 55, 0.1)'
              }}>
                <i className="fa fa-person" style={{ color: '#D4AF37' }}></i>
              </div>
              <div>
                <h6 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>Personal Information</h6>
                <small style={{ color: '#888' }}>Required for account creation</small>
              </div>
            </div>

            {/* Name Input */}
            <div className="mb-3">
              <label className="form-label small fw-semibold mb-1" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                FULL NAME
              </label>
              <div className="input-group">
                <span className="input-group-text" style={{ 
                  background: '#1a1a1a',
                  border: focusedField === 'name' ? '2px solid #D4AF37' : '1px solid rgba(212, 175, 55, 0.3)',
                  borderRight: 'none',
                  color: '#D4AF37'
                }}>
                  <i className="fa fa-person"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  style={{
                    background: '#1a1a1a',
                    border: focusedField === 'name' ? '2px solid #D4AF37' : '1px solid rgba(212, 175, 55, 0.3)',
                    borderLeft: 'none',
                    color: '#fff'
                  }}
                  placeholder="Enter Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => setFocusedField('name')}
                  onBlur={() => setFocusedField(null)}
                />
                {name.length >= 3 && (
                  <span className="input-group-text" style={{ 
                    background: '#1a1a1a',
                    border: focusedField === 'name' ? '2px solid #D4AF37' : '1px solid rgba(212, 175, 55, 0.3)',
                    borderLeft: 'none',
                    color: '#D4AF37'
                  }}>
                    <i className="fa fa-check-circle-fill"></i>
                  </span>
                )}
              </div>
              <small className="mt-1" style={{ color: name.length >= 3 ? '#D4AF37' : '#888' }}>
                <i className="fa fa-card-text me-1"></i>
                As per your PAN card
              </small>
            </div>

            {/* Email Input */}
            <div className="mb-4">
              <label className="form-label small fw-semibold mb-1" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                EMAIL ADDRESS
              </label>
              <div className="input-group">
                <span className="input-group-text" style={{ 
                  background: '#1a1a1a',
                  border: focusedField === 'email' ? '2px solid #D4AF37' : '1px solid rgba(212, 175, 55, 0.3)',
                  borderRight: 'none',
                  color: '#D4AF37'
                }}>
                  <i className="fa fa-envelope"></i>
                </span>
                <input
                  type="email"
                  className="form-control"
                  style={{
                    background: '#1a1a1a',
                    border: focusedField === 'email' ? '2px solid #D4AF37' : '1px solid rgba(212, 175, 55, 0.3)',
                    borderLeft: 'none',
                    color: '#fff'
                  }}
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={() => setFocusedField('email')}
                  onBlur={() => setFocusedField(null)}
                />
                {validateEmail(email) && (
                  <span className="input-group-text" style={{ 
                    background: '#1a1a1a',
                    border: focusedField === 'email' ? '2px solid #D4AF37' : '1px solid rgba(212, 175, 55, 0.3)',
                    borderLeft: 'none',
                    color: '#D4AF37'
                  }}>
                    <i className="fa fa-check-circle-fill"></i>
                  </span>
                )}
              </div>
              <small className="mt-1" style={{ color: validateEmail(email) ? '#D4AF37' : '#888' }}>
                <i className="fa fa-envelope-paper me-1"></i>
                For trading updates and statements
              </small>
            </div>

            {/* Terms Info - Dark Golden */}
            <div className="rounded p-3 mb-3" style={{ 
              background: 'rgba(212, 175, 55, 0.05)',
              border: '1px solid rgba(212, 175, 55, 0.15)'
            }}>
              <small style={{ color: '#D4AF37' }}>
                <i className="fa fa-info-circle me-1"></i>
                Your name should match your PAN card. Email will be used for official communication.
              </small>
            </div>

            {/* Submit Button - Golden */}
            <button
              className={`btn w-100 ${isFormValid ? 'btn-golden' : 'btn-dark-golden'}`}
              onClick={handleSubmit}
              disabled={!isFormValid || loading}
              style={{
                background: isFormValid ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : '#333',
                border: 'none',
                color: isFormValid ? '#000' : '#888',
                fontWeight: 'bold',
                padding: '12px',
                transition: 'all 0.3s ease'
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" style={{ color: '#000' }}></span>
                  Processing...
                </>
              ) : (
                <>
                  <i className="fa fa-arrow-right me-2"></i>
                  PROCEED TO KYC
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Security Footer - Dark Theme */}
      <div className="container mt-4 mb-4">
        <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
          <span className="badge px-3 py-2" style={{ 
            background: 'rgba(212, 175, 55, 0.1)',
            color: '#D4AF37',
            border: '1px solid rgba(212, 175, 55, 0.2)'
          }}>
            <i className="fa fa-lock me-1"></i>
            End-to-end Encrypted
          </span>
          <span className="badge px-3 py-2" style={{ 
            background: 'rgba(212, 175, 55, 0.1)',
            color: '#D4AF37',
            border: '1px solid rgba(212, 175, 55, 0.2)'
          }}>
            <i className="fa fa-shield-check me-1"></i>
            GDPR Compliant
          </span>
        </div>
        <small className="d-block text-center" style={{ color: '#888' }}>
          <i className="fa fa-shield-lock me-1"></i>
          Your personal information is protected with 256-bit SSL encryption
        </small>
      </div>

      <style jsx>{`
        .btn-golden {
          background: linear-gradient(145deg, #D4AF37, #B8960C);
          transition: all 0.3s ease;
        }
        .btn-golden:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(212, 175, 55, 0.3);
        }
        .btn-dark-golden {
          background: #333;
          cursor: not-allowed;
        }
        input:focus {
          box-shadow: none !important;
          outline: none;
        }
      `}</style>
    </div>
  );
};

export default PersonalDetails;